import * as React from 'react';

function SvgEmptyChartIcon(props) {
  return (
    <svg
      width={80}
      height={80}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82 9.205c4.524-1.107 8.751-2.02 12.683-2.74 4.521-.827 9.14-1.488 13.854-1.981a5.07 5.07 0 013.511.95l18.89 13.71a5.41 5.41 0 012.028 2.964l.134.497c1.137 4.284 2.335 10.11 3.595 17.478l.26 1.535c1.033 6.184 1.784 11.548 2.253 16.091l.04.4c.263 2.612-1.32 5.042-3.754 5.763-6.052 1.793-13.194 3.451-21.426 4.974l-.604.111c-8.105 1.483-14.983 2.422-20.634 2.815l-.367.025c-2.477.164-4.72-1.507-5.366-3.993-2.072-7.995-4.007-17.277-5.802-27.847l-.187-1.107c-1.566-9.346-2.593-17.21-3.082-23.59l-.028-.374C1.624 12.273 3.26 9.9 5.69 9.238l.129-.033z"
        fill="#F7F7F7"
        stroke="#0F8CFF"
        strokeWidth={1.39}
        strokeLinecap="round"
      />
      <mask
        id="empty-chart-icon_svg__a"
        maskUnits="userSpaceOnUse"
        x={1}
        y={3}
        width={63}
        height={70}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.82 9.205c4.524-1.107 8.751-2.02 12.683-2.74 4.521-.827 9.14-1.488 13.854-1.981a5.07 5.07 0 013.511.95l18.89 13.71a5.41 5.41 0 012.028 2.964l.134.497c1.137 4.284 2.335 10.11 3.595 17.478l.26 1.535c1.033 6.184 1.784 11.548 2.253 16.091l.04.4c.263 2.612-1.32 5.042-3.754 5.763-6.052 1.793-13.194 3.451-21.426 4.974l-.604.111c-8.105 1.483-14.983 2.422-20.634 2.815l-.367.025c-2.477.164-4.72-1.507-5.366-3.993-2.072-7.995-4.007-17.277-5.802-27.847l-.187-1.107c-1.566-9.346-2.593-17.21-3.082-23.59l-.028-.374C1.624 12.273 3.26 9.9 5.69 9.238l.129-.033z"
          fill="#fff"
          stroke="#fff"
          strokeWidth={1.39}
          strokeLinecap="round"
        />
      </mask>
      <g mask="url(#empty-chart-icon_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.565 4.241l21.093 15.803-14.773 2.703c-1.701.312-3.323-.867-3.623-2.633L34.565 4.241z"
          fill="#fff"
          stroke="#0F8CFF"
          strokeWidth={1.39}
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.054 32.486s3.618-3.617 6.268-1.596c1.054.804 3.194 2.629-1.005 11.232-2.383 4.882 1.988 6.305 4.595 2.74 3.777-5.164 5.162-8.642 9.728-7.559 4.28 1.016 5.435 8.76 2.125 12.508-3.309 3.749-8.35-.267-5.983-4.292 2.368-4.025 6.466-6.372 12.577-5.514"
          fill="#F7F7F7"
        />
        <path
          d="M18.054 32.486s3.618-3.617 6.268-1.596c1.054.804 3.194 2.629-1.005 11.232-2.383 4.882 1.988 6.305 4.595 2.74 3.777-5.164 5.162-8.642 9.728-7.559 4.28 1.016 5.435 8.76 2.125 12.508-3.309 3.749-8.35-.267-5.983-4.292 2.368-4.025 6.466-6.372 12.577-5.514"
          stroke="#0F8CFF"
          strokeWidth={1.39}
          strokeLinecap="round"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.799 30.44l-1.469 2.428c-4.734 7.8-8.846 14.295-12.338 19.486l-.213.317a268.087 268.087 0 01-12.484 17.018 18.511 18.511 0 01-3.773 3.575l-4.857 3.444a1.529 1.529 0 01-2.173-.424 1.674 1.674 0 01-.224-1.318l1.457-5.913a19.342 19.342 0 011.947-4.904A270.5 270.5 0 0153.81 46.154l.647-.955c3.801-5.584 8.697-12.358 14.686-20.322 1.532-2.037 4.332-2.472 6.372-.99s2.603 4.362 1.283 6.553z"
        fill="#fff"
        stroke="#0F8CFF"
        strokeWidth={1.39}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default SvgEmptyChartIcon;
